import type { Article } from "@core/features/support";
import { VideoUIMaterials } from "./VideoUIMaterials";

type Props = {
  article: Article | null;
  scrollContainer?: HTMLElement | null;
};

export function VideoUIMaterialsContainer({ article, scrollContainer }: Props) {
  if (!article) return null;

  return (
    <VideoUIMaterials article={article} scrollContainer={scrollContainer} />
  );
}

export default VideoUIMaterialsContainer;
